import { render, staticRenderFns } from "./MemberSettings.vue?vue&type=template&id=7a961302&scoped=true&lang=pug&"
import script from "./MemberSettings.vue?vue&type=script&lang=js&"
export * from "./MemberSettings.vue?vue&type=script&lang=js&"
import style0 from "./MemberSettings.vue?vue&type=style&index=0&id=7a961302&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a961302",
  null
  
)

export default component.exports